import { combineReducers } from 'redux';
import getApiReducer from '../common/utils/getApiReducer';
import { fromJS } from 'immutable';

import {
  CLEAR_COURSE_LESSONS,
  CREATE_LIBRARY_RECORD,
  DELETE_SECTION,
  FETCH_CATEGORIES,
  FETCH_COURSE_LESSONS,
  FETCH_SECTION,
  GET_LIBRARY_RECORD,
  REORDER_SECTIONS,
  REORDER_LIBRARY_VIDEOS,
  UPDATE_LIBRARY_RECORD,
  UPDATE_CATEGORY_THUMBNAIL,
  UPDATE_SECTION,
  UPLOAD_LIBRARY_VIDEO,
  UPLOAD_LIBRARY_VIDEO_PROGRESS,
} from './actions';

const categoriesReducer = getApiReducer(FETCH_CATEGORIES);
const categories = (state, action) => {
  state = categoriesReducer(state, action);

  if (action.type === `${UPDATE_SECTION}_SUCCESS`) {
    const categories = state.get('data').map(category => {
      const relevantSectionIndex = category.get('sections').findIndex(section => section.get('id') === action.json.id);

      if (relevantSectionIndex > -1) {
        const section = category.getIn(['sections', relevantSectionIndex]).set('name', action.json.name);
        return category.setIn(['sections', relevantSectionIndex], section);
      }

      return category;
    });

    return state.set('data', categories);
  }

  if (action.type === `${REORDER_SECTIONS}_SUCCESS`) {
    const categoryIndex = state
      .get('data')
      .findIndex(category => category.get('id') === parseInt(action.categoryId, 10));
    return state.setIn(['data', categoryIndex, 'sections'], fromJS(action.json));
  }

  if (action.type === `${DELETE_SECTION}_SUCCESS`) {
    const categoryIndex = state
      .get('data')
      .findIndex(category => category.get('id') === parseInt(action.categoryId, 10));
    const sectionIndex = state
      .getIn(['data', categoryIndex, 'sections'])
      .findIndex(section => section.get('id') === parseInt(action.sectionId, 10));

    return state.deleteIn(['data', categoryIndex, 'sections', sectionIndex]);
  }

  if (action.type === `${UPDATE_CATEGORY_THUMBNAIL}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === action.json.id);

    return state.set('data', data.set(index, fromJS(action.json)));
  }

  return state;
};

const courseLessonsReducer = getApiReducer(FETCH_COURSE_LESSONS);
const courseLessons = (state, action) => {
  state = courseLessonsReducer(state, action);

  if (action.type === CLEAR_COURSE_LESSONS) {
    state = state.set('data', null);
  }

  return state;
};

const videoUploadProgress = (state = { loaded: 0, total: 100 }, action) => {
  if (action.type === UPLOAD_LIBRARY_VIDEO_PROGRESS) {
    state = { loaded: action.loaded, total: action.total };
  }
  return state;
};

const videoUploading = (state = false, action) => {
  if (action.type === UPLOAD_LIBRARY_VIDEO) {
    state = action.uploading;
  }
  return state;
};

const activeSectionReducer = getApiReducer(FETCH_SECTION);

const activeSection = (state, action) => {
  state = activeSectionReducer(state, action);

  if (action.type === `${GET_LIBRARY_RECORD}_SUCCESS` || action.type === `${UPDATE_LIBRARY_RECORD}_SUCCESS`) {
    const records = state.getIn(['data', 'libraryRecords']);
    const videoIndex = records.findIndex(record => record.get('id') === action.json.id);

    state = state.setIn(['data', 'libraryRecords'], records.set(videoIndex, fromJS(action.json)));
  }

  if (action.type === `${CREATE_LIBRARY_RECORD}_SUCCESS`) {
    const records = state.getIn(['data', 'libraryRecords']);
    state = state.setIn(['data', 'libraryRecords'], records.push(fromJS(action.json)));
  }

  if (action.type === `${REORDER_LIBRARY_VIDEOS}_SUCCESS`) {
    return state.setIn(['data', 'libraryRecords'], fromJS(action.json));
  }

  if (action.type === `${UPDATE_SECTION}_SUCCESS`) {
    state = state.setIn(['data', 'name'], action.json.name);
  }

  return state;
};

export default combineReducers({
  categories,
  activeSection,
  videoUploadProgress,
  videoUploading,
  courseLessons,
});



// WEBPACK FOOTER //
// ./src/library/reducers.js